import type { Feature, FeatureSelectResult } from "../types";

export function checkVoiceSupport(): boolean {
  if (typeof window === "undefined") return false;
  return !!(navigator.mediaDevices?.getUserMedia && (window.AudioContext || (window as any).webkitAudioContext));
}

export async function checkVoiceUsable(): Promise<boolean> {
  if (!checkVoiceSupport()) return false;
  if (typeof window !== "undefined" && !window.isSecureContext) return false;
  try { if (navigator.permissions) { const result = await navigator.permissions.query({ name: "microphone" as PermissionName }); if (result.state === "denied") return false; } return true; }
  catch { return true; }
}

export async function checkMicrophonePermission(): Promise<boolean> {
  try { if (navigator.permissions) { const result = await navigator.permissions.query({ name: "microphone" as PermissionName }); if (result.state === "granted") return true; } const stream = await navigator.mediaDevices.getUserMedia({ audio: true }); stream.getTracks().forEach((t) => t.stop()); return true; }
  catch { return false; }
}

export async function selectFeature(enabledFeatures: Feature[], options?: { voiceFallbackToCallback?: boolean }): Promise<FeatureSelectResult> {
  var features = [...new Set(enabledFeatures)];
  if (features.length === 0) return { feature: null, reason: "未启用任何功能" };
  var hasVoice = features.includes("voice"), hasCallback = features.includes("callback"), hasIm = features.includes("im"), hasTextChat = features.includes("text_chat");
  var voiceFallback = options?.voiceFallbackToCallback !== false;
  if (hasVoice) { var voiceUsable = await checkVoiceUsable(); if (voiceUsable) return { feature: "voice", reason: "AI 语音接待" }; if (hasTextChat) return { feature: "text_chat", reason: "降级到文本对话" }; if (hasCallback) { if (voiceFallback) return { feature: "callback", reason: "降级到回拨" }; return { feature: "callback", reason: "回拨电话" }; } return { feature: null, reason: "浏览器不支持语音" }; }
  if (hasTextChat) return { feature: "text_chat", reason: "AI 文本对话" };
  if (hasCallback) return { feature: "callback", reason: "回拨电话" };
  if (hasIm) return { feature: "im", reason: "IM 沟通" };
  return { feature: null, reason: "未知错误" };
}

export var FEATURE_LABELS: Record<string, string> = { im: "IM 沟通", callback: "回拨电话", voice: "AI 语音接待", text_chat: "AI 文本对话", home: "联系客服" };
export var FEATURE_ICONS: Record<string, string> = { im: "💬", callback: "📞", voice: "🤖", text_chat: "💬", home: "💬" };
